<template>
  <base-dialog
    :action="onAction"
    :action-name="`${$t('common.update')}`"
    :close="onClose"
    :title="`${$t('common.edit')} ${$t('common.services.singular')}`"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-row>
        <v-col cols="12">
          <v-text-field
            outlined
            dense
            v-model="model.name"
            type="text"
            hint="This will appear on Checkout, customers' receipts, and invoices."
            persistent-hint
            label="Name"
          />

          <v-text-field
            outlined
            dense
            v-model="model.unit_label"
            type="text"
            hint="This will represent a unit of this product, such as a seat on Checkout, customers' receipts, and invoices."
            persistent-hint
            label="Unit label"
          />

          <v-text-field
            outlined
            dense
            v-model="model.statement_descriptor"
            type="text"
            hint="This will appear on customers' bank statements, so make sure it's clearly recognizable."
            persistent-hint
            label="Statement descriptor"
          />
        </v-col>
      </v-row>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"
import { isErrorResponse } from "../../services/util.service"

export default {
  components: { BaseDialog },
  props: {
    service: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      model: {
        name: '',
        statement_descriptor: '',
        unit_label: ''
      }
    }
  },
  watch: {
    'service'() {
      this.model = { ...this.service }
    }
  },
  mounted() {
    this.model = { ...this.service }
  },
  methods:{
    ...mapActions(['updateService']),
    onClose(){
      this.$emit('close')
    },
    onAction() {
      const payload = {
        id: this.id,
        ...this.model
      }

      return this.updateService(payload)
        .then((res) => {
          if (!isErrorResponse(res)) {
            this.$emit('action', payload)
          }

          return res
        })
        .catch(e => {
          console.log('UPDATE ERROR', e)
          return e
        })
    }
  }
}
</script>
